export const WILDFIRE_MAX_RADIUS_KM = 50
export const WILDFIRE_FALLBACK_RADIUS_KM = 1

export function resolveWildfireGeometry(farm, farmType) {
  if (!farm) return null
  const farmTypeNorm = String(farmType || 'point').toLowerCase()

  if (farmTypeNorm === 'polygon' && Array.isArray(farm.FarmCoordinates) && farm.FarmCoordinates.length >= 3) {
    const coordinates = farm.FarmCoordinates
      .map(c => ({ latitude: parseFloat(c.lat), longitude: parseFloat(c.log) }))
      .filter(p => Number.isFinite(p.latitude) && Number.isFinite(p.longitude))
    if (coordinates.length > 3) {
      const first = coordinates[0]
      const last = coordinates[coordinates.length - 1]
      if (first.latitude === last.latitude && first.longitude === last.longitude) coordinates.pop()
    }
    if (coordinates.length >= 3) {
      return { geometryType: 'polygon', coordinates }
    }
  }

  const geofence = (farm.GeoFences || []).find(g => g.isPrimary) || (farm.GeoFences || [])[0]
  if (geofence && geofence.geofenceRadius && geofence.geofenceCenterLat != null && geofence.geofenceCenterLog != null) {
    const radiusKm = parseFloat(geofence.geofenceRadius) / 1000
    const lat = parseFloat(geofence.geofenceCenterLat)
    const lng = parseFloat(geofence.geofenceCenterLog)
    if (radiusKm > 0 && radiusKm <= WILDFIRE_MAX_RADIUS_KM && Number.isFinite(lat) && Number.isFinite(lng)) {
      return { geometryType: 'circular', latitude: lat, longitude: lng, radius: radiusKm }
    }
  }

  const lat = parseFloat(farm.lat)
  const lng = parseFloat(farm.log)
  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    return { geometryType: 'circular', latitude: lat, longitude: lng, radius: WILDFIRE_FALLBACK_RADIUS_KM }
  }

  return null
}
